import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=b25b6070&scoped=true"
import script from "./Carousel.js?vue&type=script&lang=js&external"
export * from "./Carousel.js?vue&type=script&lang=js&external"
import style0 from "./Carousel.scss?vue&type=style&index=0&id=b25b6070&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25b6070",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotIcon: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
